module.exports = __webpack_public_path__ + "static/img/brid_ani.89fab6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/brid_ani.png
// module id = OU3B
// module chunks = 1 3